import { Alert } from "antd"
import { Field } from "redux-form"
import PropTypes from "prop-types"
import React from "react"

import { IconPickerField, InputField } from "src/inputs/connected-input-fields"
import FormattedTitle from "src/components/FormattedTitle"
import { FormattedMessage } from "react-intl"
import { OPF_ITEM_TYPES } from "../../../globals"
import { required } from "../../validators"
import LexicalEditor from "../../../inputs/rich-text/LexicalEditor"

export const TitleAndDescriptionStep = ({ cardTitle, cardDescription, itemType }) => (
  <div className="fade-in">
    {cardTitle || cardDescription ? (
      <Alert message={cardTitle} description={cardDescription} type="info" showIcon />
    ) : null}
    <div className="row">
      {itemType === OPF_ITEM_TYPES.PROCEDURE && (
        <div>
          <Field
            name="icon"
            component={IconPickerField}
            label={<FormattedTitle id="common.icon" />}
          />
        </div>
      )}
      <div style={{ flex: 1 }}>
        <Field
          name="title"
          component={InputField}
          validate={[required]}
          label={<FormattedTitle id="common.title" />}
          required
        />
      </div>
    </div>
    <div className="row">
      <div style={{ flex: 1 }}>
        <label>{<FormattedTitle id="common.description" />}</label>
        <Field name="text" component={LexicalEditor} className="area" />
      </div>
    </div>
    {(itemType === OPF_ITEM_TYPES.PROCESS_ELEMENT ||
      itemType === OPF_ITEM_TYPES.PROCEDURE_CATEGORY) && (
      <div className="row">
        <div style={{ flex: 1 }}>
          <Field
            name="redirectSlug"
            component={InputField}
            label={<FormattedMessage id="common.slug" />}
          />
        </div>
      </div>
    )}
  </div>
)

TitleAndDescriptionStep.propTypes = {
  cardTitle: PropTypes.any,
  cardDescription: PropTypes.any,
}

export default TitleAndDescriptionStep
